import _object_spread from "@swc/helpers/src/_object_spread.mjs";
import _object_spread_props from "@swc/helpers/src/_object_spread_props.mjs";
import _sliced_to_array from "@swc/helpers/src/_sliced_to_array.mjs";
import _tagged_template_literal from "@swc/helpers/src/_tagged_template_literal.mjs";
function _templateObject() {
    var data = _tagged_template_literal([
        "\n  *,\n  *:before,\n  *:after {\n    box-sizing: border-box;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _tagged_template_literal([
        ""
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _tagged_template_literal([
        ""
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _tagged_template_literal([
        ""
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = _tagged_template_literal([
        ""
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = _tagged_template_literal([
        "\n    color: ",
        ";\n  "
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = _tagged_template_literal([
        "\n  ",
        "\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = _tagged_template_literal([
        ""
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = _tagged_template_literal([
        "\n  &:first-child {\n    margin-top: 0;\n  }\n"
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = _tagged_template_literal([
        "\n  ",
        "\n"
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = _tagged_template_literal([
        "\n  ",
        "\n"
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function _templateObject11() {
    var data = _tagged_template_literal([
        ""
    ]);
    _templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}
function _templateObject12() {
    var data = _tagged_template_literal([
        ""
    ]);
    _templateObject12 = function _templateObject12() {
        return data;
    };
    return data;
}
function _templateObject13() {
    var data = _tagged_template_literal([
        "\n  &:nth-of-type(1) {\n    ",
        "\n  }\n  &:nth-of-type(2) {\n    ",
        "\n  }\n"
    ]);
    _templateObject13 = function _templateObject13() {
        return data;
    };
    return data;
}
function _templateObject14() {
    var data = _tagged_template_literal([
        ""
    ]);
    _templateObject14 = function _templateObject14() {
        return data;
    };
    return data;
}
function _templateObject15() {
    var data = _tagged_template_literal([
        "\n  &:last-child {\n    margin-right: 0;\n  }\n"
    ]);
    _templateObject15 = function _templateObject15() {
        return data;
    };
    return data;
}
function _templateObject16() {
    var data = _tagged_template_literal([
        ""
    ]);
    _templateObject16 = function _templateObject16() {
        return data;
    };
    return data;
}
function _templateObject17() {
    var data = _tagged_template_literal([
        ""
    ]);
    _templateObject17 = function _templateObject17() {
        return data;
    };
    return data;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import { menu, footerLinks, socialItems } from "./data";
import FooterSocial from "./FooterSocial";
import FooterLinks from "./FooterLinks";
import FooterIcons from "./FooterIcons";
import styled, { css, ThemeProvider } from "styled-components";
import { Box, Link, LanguageSwitcher, useWindowSize } from "@miro-site/core";
import theme from "./theme";
import { AccordionMenu } from "@miro-site/ui-page-sections/header";
import { usePageTranslations } from "@miro-site/localization";
import { useLocalization } from "@miro-site/localization";
var FooterComponent = styled(Box).attrs({
    as: "footer",
    $styles: {
        background: theme.footer.background,
        fontFamily: "Formular",
        fontFeatureSettings: "'ss03'"
    }
}).withConfig({
    componentId: "sc-35c56958-0"
})(_templateObject());
var FooterContainer = styled(Box).attrs({
    $styles: {
        maxWidth: theme.footer.container.width,
        margin: theme.footer.container.margin,
        paddingTop: theme.footer.container.padding.top,
        paddingLeft: theme.footer.container.padding.left,
        paddingRight: theme.footer.container.padding.right,
        paddingBottom: theme.footer.container.padding.bottom
    }
}).withConfig({
    componentId: "sc-35c56958-1"
})(_templateObject1());
var FooterList = styled(Box).attrs({
    as: "ul",
    $styles: {
        display: "flex",
        flexDirection: "row",
        justifyContent: "space-between",
        flexWrap: "wrap",
        marginLeft: theme.footer.list.margin,
        marginRight: theme.footer.list.margin,
        paddingRight: theme.footer.list.padding.right
    }
}).withConfig({
    componentId: "sc-35c56958-2"
})(_templateObject2());
var FooterListItem = styled(Box).attrs({
    as: "li",
    $styles: {
        flex: "0 0 20%",
        paddingLeft: theme.footer.item.padding,
        paddingRight: theme.footer.item.padding
    }
}).withConfig({
    componentId: "sc-35c56958-3"
})(_templateObject3());
var FooterListTitleWrapper = styled(Box).attrs({
    $styles: {
        marginBottom: theme.footer.categoryWrapper.margin.bottom
    }
}).withConfig({
    componentId: "sc-35c56958-4"
})(_templateObject4());
var FooterListTitle = styled(Box).attrs({
    as: "h3",
    $styles: {
        fontSize: theme.footer.categoryTitle.fontSize,
        lineHeight: theme.footer.categoryTitle.lineHeight,
        fontWeight: theme.footer.categoryTitle.fontWeight
    }
}).withConfig({
    componentId: "sc-35c56958-5"
})(_templateObject6(), function(param) {
    var _$theme = param.theme;
    return css(_templateObject5(), _$theme.colors.primaryWhite);
});
var FooterInnerWrapper = styled(Box).attrs(function(param) {
    var $isActive = param.$isActive;
    return {
        $styles: {
            overflow: [
                "hidden",
                null
            ]
        }
    };
}).withConfig({
    componentId: "sc-35c56958-6"
})(_templateObject7());
var FooterInnerItem = styled(Box).attrs({
    as: "li",
    $mt: theme.footer.innerItem.margin.top
}).withConfig({
    componentId: "sc-35c56958-7"
})(_templateObject8());
var FooterInnerLink = styled(Link).withConfig({
    componentId: "sc-35c56958-8"
})(_templateObject9(), function(props) {
    return props.theme.normalizeStyles(theme.footer.links.menu);
});
var FooterAdditionalLink = styled(Link).attrs({}).withConfig({
    componentId: "sc-35c56958-9"
})(_templateObject10(), function(props) {
    return props.theme.normalizeStyles(theme.footer.links.additional);
});
var FooterBottomContainer = styled(Box).attrs({
    $styles: {
        borderTop: "1px solid #9B99AF"
    },
    $mt: theme.footer.bottomContainer.margin.top,
    $pt: theme.footer.bottomContainer.padding.top
}).withConfig({
    componentId: "sc-35c56958-10"
})(_templateObject11());
var FooterRow = styled(Box).attrs({
    as: "div",
    $styles: {
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        flexWrap: "wrap",
        textAlign: [
            "center",
            "center"
        ]
    }
}).withConfig({
    componentId: "sc-35c56958-11"
})(_templateObject12());
var FooterCol = styled(Box).attrs({
    $styles: {
        flex: [
            "0 0 100%",
            "0 0 100%",
            "0 0 auto",
            "0 0 auto",
            "0 0 auto"
        ]
    }
}).withConfig({
    componentId: "sc-35c56958-12"
})(_templateObject13(), function(param) {
    var _$theme = param.theme;
    return _$theme.normalizeStyles({
        order: [
            2,
            2,
            1,
            1
        ]
    });
}, function(param) {
    var _$theme = param.theme;
    return _$theme.normalizeStyles({
        order: [
            1,
            1,
            2,
            2
        ]
    });
});
var FooterInnerRow = styled(Box).attrs({
    $styles: {
        display: "flex",
        justifyContent: [
            "center",
            "center",
            "",
            "",
            ""
        ],
        alignItems: "center",
        flexWrap: "wrap"
    }
}).withConfig({
    componentId: "sc-35c56958-13"
})(_templateObject14());
var FooterInnerCol = styled(Box).attrs({
    $styles: {
        flex: [
            "0 0 100%",
            "0 0 100%",
            "0 0 auto"
        ]
    },
    $mr: theme.footer.innerColumn.margin.right
}).withConfig({
    componentId: "sc-35c56958-14"
})(_templateObject15());
var FooterInnerColWrapper = styled(Box).attrs({
    $styles: {
        display: "flex",
        flexWrap: [
            "wrap",
            "wrap",
            undefined
        ],
        justifyContent: [
            "center",
            "center",
            undefined
        ]
    }
}).withConfig({
    componentId: "sc-35c56958-15"
})(_templateObject16());
var LanguageSwitcherContainer = styled(Box).attrs({
    $mr: [
        null,
        null,
        20,
        24
    ]
}).withConfig({
    componentId: "sc-35c56958-16"
})(_templateObject17());
var Footer = function(props) {
    var label = props.label, _categories = props.categories, categories = _categories === void 0 ? menu : _categories, _socialMedia = props.socialMedia, socialMedia = _socialMedia === void 0 ? socialItems : _socialMedia, _bottomLinks = props.bottomLinks, bottomLinks = _bottomLinks === void 0 ? footerLinks : _bottomLinks;
    var ref = _sliced_to_array(usePageTranslations(), 2), switcherData = ref[0], onChangeLocale = ref[1].onChangeLocale;
    var width = useWindowSize().width;
    var currentLocale = useLocalization().currentLocale;
    var isRUlocale = currentLocale == "ru" ? true : false;
    var isMobileScreen = width <= theme.breakpoints.v2Tablet;
    return /*#__PURE__*/ _jsx(ThemeProvider, {
        theme: function(defaultTheme) {
            return _object_spread({}, defaultTheme, theme);
        },
        children: /*#__PURE__*/ _jsx(FooterComponent, {
            "data-place": "footer",
            children: /*#__PURE__*/ _jsxs(FooterContainer, {
                children: [
                    !isMobileScreen && /*#__PURE__*/ _jsx("nav", {
                        "aria-label": label,
                        "data-track-place": "Footer",
                        children: /*#__PURE__*/ _jsx(FooterList, {
                            children: categories.map(function(category, categoryIndex) {
                                return /*#__PURE__*/ _jsxs(FooterListItem, {
                                    children: [
                                        /*#__PURE__*/ _jsx(FooterListTitleWrapper, {
                                            children: /*#__PURE__*/ _jsx(FooterListTitle, {
                                                children: category.title
                                            })
                                        }),
                                        /*#__PURE__*/ _jsx(FooterInnerWrapper, {
                                            children: /*#__PURE__*/ _jsx("ul", {
                                                children: category.groups.map(function(subcategory, subcategoryIndex) {
                                                    return /*#__PURE__*/ _jsxs(FooterInnerItem, {
                                                        children: [
                                                            /*#__PURE__*/ _jsx("ul", {
                                                                children: subcategory.items.map(function(link, linkIndex) {
                                                                    return /*#__PURE__*/ _jsx(FooterInnerItem, {
                                                                        children: /*#__PURE__*/ _jsx(FooterInnerLink, {
                                                                            href: link.path,
                                                                            $color: "white",
                                                                            $size: "medium",
                                                                            children: link.title
                                                                        })
                                                                    }, linkIndex);
                                                                })
                                                            }),
                                                            subcategory.viewAllLink && !isRUlocale && /*#__PURE__*/ _jsx(FooterAdditionalLink, {
                                                                href: subcategory.viewAllLink.path,
                                                                $variant: "regular",
                                                                $color: "white",
                                                                $size: "medium",
                                                                withArrow: true,
                                                                children: subcategory.viewAllLink.title
                                                            })
                                                        ]
                                                    }, subcategoryIndex);
                                                })
                                            })
                                        })
                                    ]
                                }, categoryIndex);
                            })
                        })
                    }),
                    isMobileScreen && /*#__PURE__*/ _jsx(AccordionMenu, {
                        categories: categories
                    }),
                    /*#__PURE__*/ _jsx(FooterBottomContainer, {
                        children: /*#__PURE__*/ _jsxs(FooterRow, {
                            children: [
                                /*#__PURE__*/ _jsx(FooterCol, {
                                    children: /*#__PURE__*/ _jsxs(FooterInnerRow, {
                                        children: [
                                            /*#__PURE__*/ _jsx(FooterInnerCol, {
                                                children: /*#__PURE__*/ _jsx(FooterSocial, {
                                                    items: socialMedia
                                                })
                                            }),
                                            /*#__PURE__*/ _jsx(FooterInnerCol, {
                                                children: /*#__PURE__*/ _jsxs(FooterInnerColWrapper, {
                                                    children: [
                                                        /*#__PURE__*/ _jsx(LanguageSwitcherContainer, {
                                                            children: switcherData && /*#__PURE__*/ _jsx(LanguageSwitcher, _object_spread_props(_object_spread({}, switcherData), {
                                                                onSelect: function(e, link) {
                                                                    onChangeLocale(link.locale);
                                                                },
                                                                color: "white",
                                                                position: "top"
                                                            }))
                                                        }),
                                                        /*#__PURE__*/ _jsx(FooterLinks, {
                                                            links: bottomLinks
                                                        })
                                                    ]
                                                })
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ _jsx(FooterCol, {
                                    children: /*#__PURE__*/ _jsx(FooterIcons, {})
                                })
                            ]
                        })
                    })
                ]
            })
        })
    });
};
export default Footer;
